import React, { useEffect, createElement } from 'react';
import { useParams } from 'react-router-dom';
import { trackVisit } from '../lib/analytics';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { MarqueeBanner } from '../components/MarqueeBanner';
import { AboutSection } from '../components/AboutSection';
import { ProjectsSection } from '../components/ProjectsSection';
import { ExperimentsSection } from '../components/ExperimentsSection';
import { WritingSection } from '../components/WritingSection';
import { MusicSection } from '../components/MusicSection';
import { ContactSection } from '../components/ContactSection';
import { NotificationBar } from '../components/NotificationBar';
import { useSiteSettings } from '../lib/cmsStore';
interface PortfolioPageProps {
  /** Content type for deep linking */
  openType?: 'work' | 'experiments' | 'writing' | 'music';
}
export function PortfolioPage({
  openType
}: PortfolioPageProps) {
  const params = useParams<{
    slug: string;
  }>();
  const slug = params.slug;
  const {
    data,
    isLoading
  } = useSiteSettings();
  // Track visit on mount
  useEffect(() => {
    const path = openType && slug ? `/${openType}/${slug}` : '/';
    trackVisit(path);
  }, [openType, slug]);
  // Apply design tokens from CMS to CSS custom properties
  useEffect(() => {
    if (isLoading || !data) return;
    const root = document.documentElement;
    if (data.primaryColor) {
      const primary = data.primaryColor.replace(/^hsl\(/, '').replace(/\)$/, '').trim();
      if (primary) {
        root.style.setProperty('--primary', primary);
        root.style.setProperty('--accent', primary);
        root.style.setProperty('--ring', primary);
        root.style.setProperty('--sidebar-primary', primary);
        root.style.setProperty('--sidebar-ring', primary);
      }
    }
    if (data.backgroundColor) {
      const bg = data.backgroundColor.replace(/^hsl\(/, '').replace(/\)$/, '').trim();
      if (bg) {
        root.style.setProperty('--background', bg);
      }
    }
    if (data.displayFont) {
      root.style.setProperty('--font-display', data.displayFont);
    }
    if (data.monoFont) {
      root.style.setProperty('--font-mono', data.monoFont);
    }
    document.title = data.siteTitle || 's1nka — Matsade Mdzinavs';
    if (data.siteDescription) {
      let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.appendChild(meta);
      }
      meta.content = data.siteDescription;
    }
  }, [data, isLoading]);
  const isVisible = (section: string) => {
    if (isLoading || !data?.sectionVisibility) return true;
    return data.sectionVisibility[section] !== false;
  };
  return <div className="grain" data-id="element-1690">
      <NotificationBar data-id="element-1691" />
      <Navigation data-id="element-1692" />
      <HeroSection data-id="element-1693" />
      <MarqueeBanner data-id="element-1694" />
      {isVisible('about') && <AboutSection data-id="element-1695" />}
      {isVisible('work') && <ProjectsSection initialSlug={openType === 'work' ? slug : undefined} data-id="element-1696" />}
      {isVisible('experiments') && <ExperimentsSection initialSlug={openType === 'experiments' ? slug : undefined} data-id="element-1697" />}
      {isVisible('writing') && <WritingSection initialSlug={openType === 'writing' ? slug : undefined} data-id="element-1698" />}
      {isVisible('music') && <MusicSection initialSlug={openType === 'music' ? slug : undefined} data-id="element-1699" />}
      {isVisible('contact') && <ContactSection data-id="element-1700" />}
    </div>;
}